module.exports = __webpack_public_path__ + "static/media/building.fb20d4df.svg";